export default "__VITE_ASSET__DuS_wxtu__"